"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Svg = __importStar(require("react-native-svg"));
exports.default = (props) => (React.createElement(Svg.Svg, Object.assign({}, props, { viewBox: '0 0 24 24' }),
    React.createElement(Svg.G, { "data-name": 'Layer 2' },
        React.createElement(Svg.G, { "data-name": 'toggle-left' },
            React.createElement(Svg.Rect, { x: '.02', y: '.02', width: '23.97', height: '23.97', transform: 'rotate(179.92 12.002 11.998)', opacity: '0' }),
            React.createElement(Svg.Path, { d: 'M15 5H9a7 7 0 0 0 0 14h6a7 7 0 0 0 0-14zM9 15a3 3 0 1 1 3-3 3 3 0 0 1-3 3z' }),
            React.createElement(Svg.Path, { d: 'M9 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2z' })))));
//# sourceMappingURL=ToggleLeft.js.map